import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'toggle', 'panel', 'wheel'];

  connect() {
    this.outside = event => { if(!this.element.contains(event.target)) this.close(); };
    document.addEventListener('pointerdown', this.outside);
    this.observer = new MutationObserver(() => {
      this.toggleTarget.disabled = this.inputTarget.disabled;
      if(this.inputTarget.disabled) this.close();
    });
    this.observer.observe(this.inputTarget, {attributes:true, attributeFilter:['disabled']});
    this.toggleTarget.disabled = this.inputTarget.disabled;
  }

  disconnect() {
    document.removeEventListener('pointerdown', this.outside);
    this.observer.disconnect();
    this.wheelTargets.forEach(wheel => clearTimeout(wheel.timeTimer));
  }

  toggle() {
    if(!this.panelTarget.hidden) { this.close(); return; }
    if(this.inputTarget.disabled) return;
    this.original = this.inputTarget.value;
    this.parts = /^\d{2}:\d{2}$/.test(this.original) ? this.original.split(':').map(Number) : [12,0];
    this.panelTarget.hidden = false;
    this.toggleTarget.setAttribute('aria-expanded', 'true');
    this.wheelTargets.forEach((wheel, index) => this.align(wheel, this.parts[index]));
    this.wheelTargets[0].focus({preventScroll:true});
  }

  openField(event) {
    if(event.target === this.inputTarget || event.target.closest('button, .cart-time-picker')) return;
    if(this.panelTarget.hidden) this.toggle();
  }

  align(wheel, value) {
    wheel.scrollTop = value * 32;
    this.select(wheel, value);
  }

  select(wheel, value) {
    const index = wheel.dataset.part === 'hours' ? 0 : 1;
    this.parts[index] = value;
    wheel.querySelectorAll('[role=option]').forEach(button => button.setAttribute('aria-selected', String(Number(button.dataset.value) === value)));
  }

  scroll(event) {
    const wheel = event.currentTarget;
    clearTimeout(wheel.timeTimer);
    wheel.timeTimer = setTimeout(() => {
      if(this.panelTarget.hidden) return;
      this.select(wheel, Math.max(0, Math.min(wheel.children.length - 1, Math.round(wheel.scrollTop / 32))));
    }, 120);
  }

  choose(event) {
    const button = event.currentTarget;
    this.align(button.closest('[role=listbox]'), Number(button.dataset.value));
  }

  key(event) {
    if(!['ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const wheel = event.currentTarget;
    const index = wheel.dataset.part === 'hours' ? 0 : 1;
    const limit = wheel.children.length - 1;
    const value = event.key === 'Home' ? 0 : event.key === 'End' ? limit : this.parts[index] + (event.key === 'ArrowDown' ? 1 : -1);
    this.align(wheel, Math.max(0, Math.min(limit, value)));
  }

  leave(event) {
    if(event.relatedTarget && !this.element.contains(event.relatedTarget)) this.close();
  }

  editing() {
    this.wheelTargets.forEach(wheel => clearTimeout(wheel.timeTimer));
    this.panelTarget.hidden = true;
    this.toggleTarget.setAttribute('aria-expanded', 'false');
  }

  close() {
    if(this.panelTarget.hidden) return;
    // Read the final wheel position even if the scroll debounce has not fired yet.
    this.wheelTargets.forEach(wheel => {
      clearTimeout(wheel.timeTimer);
      this.select(wheel, Math.max(0, Math.min(wheel.children.length - 1, Math.round(wheel.scrollTop / 32))));
    });
    this.panelTarget.hidden = true;
    this.toggleTarget.setAttribute('aria-expanded', 'false');
    if(this.inputTarget.disabled) return;
    this.inputTarget.value = this.parts.map(value => String(value).padStart(2,'0')).join(':');
    if(this.inputTarget.value !== this.original) this.inputTarget.dispatchEvent(new Event('change', {bubbles:true}));
  }
}
